import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    descripcion: '',
    rubroTrabajoId: 0,
    rubroTrabajo: null,
    rubroTrabajoNombre: null,
    inactivo: false,
    rowVersion: null,
    
    articuloTipoDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_ARTICULO_TIPO'(state, articuloTipoId) {
        state.id = articuloTipoId;
        state.nombre = '';
        state.descripcion = '';
        state.rubroTrabajoId = 0;
        state.rubroTrabajo = null;
        state.rubroTrabajoNombre = null;
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_ARTICULO_TIPO'(state, articuloTipo) {
        state.nombre = articuloTipo.nombre.toUpperCase().trim();
        state.descripcion = articuloTipo.descripcion.toUpperCase().trim();
        state.rubroTrabajoId = articuloTipo.rubroTrabajo? articuloTipo.rubroTrabajo.id : 0;
        state.rubroTrabajo = articuloTipo.rubroTrabajo;
        state.rubroTrabajoNombre = articuloTipo.rubroTrabajo? articuloTipo.rubroTrabajo.nombre.trim() : null;
        state.inactivo = articuloTipo.inactivo;
        state.rowVersion = articuloTipo.rowVersion;
    },
    'SET_RUBRO_TRABAJO'(state, rubroTrabajo) {
        state.rubroTrabajo = rubroTrabajo;
        state.rubroTrabajoId = rubroTrabajo? rubroTrabajo.id : 0;
        state.rubroTrabajoNombre = rubroTrabajo? rubroTrabajo.nombre.trim() : null;
    },

    'SET_ARTICULO_TIPO_ID' (state, articuloTipo) {
        state.id = articuloTipo.id;
        state.rowVersion = articuloTipo.rowVersion;
    },

    'INICIALIZAR_DATOS'(state) {
        state.articuloTipoDatos = [];
    },
    'SET_DATOS'(state, params) {
        state.articuloTipoDatos = params.articuloTipoDatos;
    },
};

const getters = {
    getField,

    articuloTipo(state) {
        return {
            id: state.id,
            nombre: state.nombre.toUpperCase().trim(),
            descripcion: state.descripcion.toUpperCase().trim(),
            rubroTrabajoId: state.rubroTrabajoId,
            inactivo: state.inactivo,
            rowVersion: state.rowVersion,
        }
    }
};

const actions = {
    inicializar ( { commit }, articuloTipoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_ARTICULO_TIPO', articuloTipoId);
            if (articuloTipoId != 0){
                apiAxios.get('articulostipos/' + articuloTipoId + '/abm' ) 
                    .then(res => {
                        commit('SET_ARTICULO_TIPO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },    
    save ( {commit} ) {
        return new Promise((resolve, reject) => {
            let articuloTipo= {
                nombre: state.nombre.toUpperCase().trim(),
                descripcion: state.descripcion.trim(),
                rubroTrabajoId: state.rubroTrabajoId,
                inactivo: state.inactivo,
                rowVersion: state.rowVersion,
            }
            let url = 'articulostipos';

            if (state.id != 0) {
                url += '/' + state.id;
            }

            apiAxios.post(url, articuloTipo)
                .then((res) => {
                    /* Actualizamos Id y RowVersion */
                    commit('SET_ARTICULO_TIPO_ID', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setRubroTrabajo: ({commit}, rubroTrabajo) => {
        commit('SET_RUBRO_TRABAJO', rubroTrabajo);
    },

    inactivar ( {}, articuloTipoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('articulostipos/' + articuloTipoId + '/inactivar')
                .then(() => {
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getDatos ( { commit }, articuloTipoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (articuloTipoId != 0) {
                apiAxios.get('articulostipos/' + articuloTipoId) 
                    .then(res => {
                        let datos = [
                            { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'descripcion', 'campo': 'Descripcion', 'valor': res.data.descripcion, 'formato': '' },
                            { 'nombre': 'rubroTrabajo', 'campo': 'Rubro', 'valor': res.data.rubroTrabajo, 'formato': '' },
                            // { 'nombre': 'diasProduccion', 'campo': 'Dias Producción:', 'valor': res.data.diasProduccion, 'formato': '' },
                            // { 'nombre': 'unidades', 'campo': 'Unidades', 'valor': res.data.unidades, 'formato': '' },
                            { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': res.data.inactivo? 'Si' : 'No', 'formato': '' },
                        ];
                        let params = {
                            articuloTipoDatos: datos,
                        }
                        commit('SET_DATOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}